export default "__VITE_ASSET__CqZOC9Fw__"